import { render, staticRenderFns } from "./EditTemplateImagem.vue?vue&type=template&id=639fe94e&scoped=true&"
import script from "./EditTemplateImagem.vue?vue&type=script&lang=js&"
export * from "./EditTemplateImagem.vue?vue&type=script&lang=js&"
import style0 from "./EditTemplateImagem.vue?vue&type=style&index=0&id=639fe94e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639fe94e",
  null
  
)

export default component.exports